import _ from "lodash";

function valueCountsToChartFormat(valueCounts, allKeys) {
  return allKeys.map(key => ({
    key: key,
    value: key in valueCounts ? valueCounts[key] : 0
  }));
}

export function countOfMultipleChoice(filteredData, allKeys, dataField) {
  //  [
  //     {key: "1", value: 24},
  //     ...
  // ]
  // NOTE we drop null values
  // NOTE One person can only experience one legal category, what we use Set() for ???
  // ERIC - I don't think the above note is true people can experience multiple legal problems in the same category
  return valueCountsToChartFormat(
    _.countBy(
      _.flatten(filteredData.map(value => value[dataField])).filter(Number)
    ),
    allKeys
  );
}

export function countOfSingleChoice(filteredData, allKeys, dataField) {
  //  [
  //     { key: string, value: int },
  //     ...
  // ]
  return valueCountsToChartFormat(
    _.countBy(filteredData.map(value => value[dataField])),
    allKeys
  );
}

export function resolutionSankeyDiagram(filteredData) {
  // create an object of the unique counts
  // [{key0: "1", key1: "2", key2: "1", value: 40}, ...]

  // We want to drop those who did not experience a legal problem
  const resolutionPathsAndCount = {};
  let value = "";
  for (const respondent of filteredData) {
    if (respondent.resolutionStatus) {
      const key = `${respondent.attemptedResolution}+${respondent.resolutionActionType}+${respondent.resolutionStatus}`;
      if (resolutionPathsAndCount[key] == null) {
        value = 1;
      } else {
        value = resolutionPathsAndCount[key] + 1;
      }
      resolutionPathsAndCount[key] = value;
    }
  }

  // break up the string and make the resolution sankey array
  const resolutionSankeyDiagram = [];
  for (const option in resolutionPathsAndCount) {
    const options = option.split("+");
    const people = resolutionPathsAndCount[option];
    resolutionSankeyDiagram.push({
      // resolution attempted
      1: options[0],
      // resolution action type
      2: options[1],
      // resolution status
      3: options[2],
      value: people
    });
  }
  return resolutionSankeyDiagram;
}

function createMechanismsObject(filteredData, mechanismName) {
  const mechanismObject = _.countBy(
    _.flatten(filteredData.map(value => value[mechanismName]))
  );
  delete mechanismObject["null"];
  return mechanismObject;
}

export function scatterHelpfulness(filteredData) {
  // TODO this needs to become the scatter plot
  // [{key: "3-1", values: [28, 12] }, ...]

  const mostHelpfulSource = _.countBy(
    filteredData.map(value => value["mostHelpfulSource"])
  );
  delete mostHelpfulSource["null"];
  const respondents = _.sum(_.values(mostHelpfulSource));

  const mechanismsMapper = {
    "1": createMechanismsObject(filteredData, "selfActionMechanisms"),
    "2": createMechanismsObject(filteredData, "personalNetworkMechanisms"),
    "3": createMechanismsObject(filteredData, "institutionsMechanisms")
  };

  const helpfulnessAndUse = [];
  for (let key in mostHelpfulSource) {
    const mechanismCatAndType = key.split("-");
    const numberOfPeopleWhoUsedMechanism =
      mechanismsMapper[mechanismCatAndType[0]][mechanismCatAndType[1]];
    const numberOfPeopleWhoFoundMechanismHelpful = mostHelpfulSource[key];
    if (
      numberOfPeopleWhoFoundMechanismHelpful &&
      numberOfPeopleWhoUsedMechanism > 2
    ) {
      helpfulnessAndUse.push({
        key: key,
        value: [
          numberOfPeopleWhoUsedMechanism / respondents,
          numberOfPeopleWhoFoundMechanismHelpful /
            numberOfPeopleWhoUsedMechanism
        ]
      });
    }
  }

  return helpfulnessAndUse;
}

export function subLegalProblems(filteredData, filteredDataNoLP) {
  const allFilteredRespondents = filteredData.length + filteredDataNoLP.length;
  const problemsAndCountExperienced = _.countBy(
    _.flatten(filteredData.map(value => value["subLegalProblemsExperienced"]))
  );
  const percentPeopleExperience = {};
  Object.keys(problemsAndCountExperienced).map(function(key, index) {
    percentPeopleExperience[key] = (
      (problemsAndCountExperienced[key] / allFilteredRespondents) *
      100
    ).toFixed(1);
  });
  const problemsAndCountSevere = _.countBy(
    _.flatten(filteredData.map(value => value["subSevereLegalProblem"]))
  );
  const percentPeopleSevere = {};
  Object.keys(problemsAndCountSevere).map(function(key, index) {
    percentPeopleSevere[key] = (
      (problemsAndCountSevere[key] / allFilteredRespondents) *
      100
    ).toFixed(1);
  });

  return Object.keys(problemsAndCountExperienced).map(key => ({
    key: key,
    experiencedCount: problemsAndCountExperienced[key],
    percentPeopleExperience: percentPeopleExperience[key],
    severeCount: problemsAndCountSevere[key],
    percentPeopleSevere: percentPeopleSevere[key]
  }));
}

export function reasonNoAction(filteredData) {
  const filteredRespondents = filteredData.length;
  const reasonAndCount = _.countBy(
    _.flatten(filteredData.map(value => value["reasonForNoAction"]))
  );
  const percentReason = {};
  Object.keys(reasonAndCount).map(function(key, index) {
    percentReason[key] = (
      (reasonAndCount[key] / filteredRespondents) *
      100
    ).toFixed(1);
  });
  return Object.keys(reasonAndCount).map(key => ({
    key: key,
    peopleCount: reasonAndCount[key],
    peoplePercent: percentReason[key]
  }));
}

export function impactIndex(filteredData) {
  return _.sortBy(
    _(filteredData)
      .groupBy("severeLegalProblem")
      .map((legalProblem, id) => ({
        key: id,
        value: _.meanBy(legalProblem, "impactIndex").toFixed(3)
      }))
      .value(),
    "value"
  ).reverse();
}
